import { handleCompanyUrl } from 'utils/organizationUtils';

const ReloadStringsArray = ['/group/edit'];
export const CompanyUrlsArray = ReloadStringsArray.map((url: string) => handleCompanyUrl(url));
